import styled from "styled-components";

const gapSize = 12;

export const Gap = styled.div`
  padding: ${({ x = 1 }) => x * 12}px;
`;
